








import { Component, Vue, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";

@Component
export default class IndicatorBaseConfigBase extends BaseVue {
  created() {
  }
}
